import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Input as CoreInput } from '@sparefoot/react-core';
import { Text } from 'components/core/Typography';

import './SlideToggler.scss';

export default function SlideToggler({
	id,
	name,
	value,
	checked,
	label,
	onChange,
	extraLabel,
}) {
	return (
		<label
			className="ss-slide-toggler"
			htmlFor={name}
		>
			<CoreInput
				id={id}
				type="checkbox"
				className={classnames({ checked }, 'ss-slider-input')}
				onChange={onChange}
				checked={checked}
				value={value}
				name={name}
			/>
			<button
				className={classnames({ checked }, 'slider-box')}
				onClick={onChange}
			/>
			<Text
				className="slide-toggler-label"
				size="small"
				weight="medium"
				color="white"
				last
			>
				{label}
				{!!extraLabel && (
					<Text
						className="extra-label"
						color="white"
						last
					>
						{extraLabel}
					</Text>
				)}
			</Text>
		</label>
	);
}

SlideToggler.propTypes = {
	id: PropTypes.string.isRequired,
	name: PropTypes.string.isRequired,
	value: PropTypes.string.isRequired,
	label: PropTypes.string.isRequired,
	onChange: PropTypes.func.isRequired,
	checked: PropTypes.bool,
	extraLabel: PropTypes.string,
};
